<template>
    <div>
        <div>
            <el-form :model="form" :inline="true"  style="text-align:left;">
                <el-form-item label="综合查询:">
                    <el-input v-model="form.dicTypeName" placeholder="请输入品类名称" :clearable="true" class="query-input"></el-input>
                </el-form-item> 
                <el-form-item label="状态:">
                    <My-Select v-model="form.state" :objSelect="form.state" :options="options" :placeholder="placeholder" @changeSelct="changeSelct"></My-Select>                 
                </el-form-item> 
                <el-form-item >
                    <el-button type="primary" plain @click="query()">查询</el-button>  
                    <el-button type="primary" plain @click="categoryEditor('add')">新建</el-button>                         
                </el-form-item>           
            </el-form>
        </div>
        <div>
            <My-table :configurationData="configurationData"  :operation="operation" :getTableParam="getTableParam" ref="myTable">           
                <template #operation="scope">        
                    <el-button size="mini" type="primary" @click="categoryEditor('update',scope.row)">修改</el-button>
                </template>
            </My-table> 
        </div>

        <el-dialog :title="title" :visible.sync="categoryDialog" :close-on-click-modal=false width="500px">
            <el-form :model="editorForm" :rules="rules" ref="editorForm" label-width="100px" style="text-align:left">
                <el-form-item label="品类名称:" prop="dicTypeName">
                    <el-input v-model="editorForm.dicTypeName" placeholder="请输入品类名称"></el-input>
                </el-form-item>
                <el-form-item label="状态:" prop="state" >
                    <el-switch v-model="editorForm.state"></el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('editorForm')">确定</el-button>
                    <el-button @click="resetForm('editorForm')">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>          
    </div>
    
</template>

<script>
import common from "../../../public/static/common.js"
export default { 

    name: 'categoryMaintenance',
    data(){
        return{
            title:'',
            operationType:'',
            placeholder:'请选择查询状态',
            form:{
                dicTypeName:'',
                state:''
            },
            editorForm:{
                id:'',
                dicTypeName:'',
                state:true,
                createUser:'',
                modifyUser:'',
            },
             // 列表配置
            configurationData:[
                {
                    title: '品类名称',
                    propertys: 'dicTypeName',
                    width: ''
                },
                {
                    title: '状态',
                    propertys: 'state',
                    width: '',
                    format:common.formatState
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: true,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/dicProdType/page',
                param:this.form
            },
            categoryDialog:false,
            options:[
                {"key":'',"value":'全部'},
                {"key":'N',"value":'停用中'},
                {"key":'Y',"value":'使用中'}
            ],
            rules: {
                dicTypeName: [
                    { required: true, message: '请输入品类名称', trigger: 'blur' }
                ],
                state: [
                    { required: true, trigger: 'blur' }
                ]
            }
        }
    },
    methods:{
        categoryEditor(operationType,row){    
            this.operationType=operationType;       
            if(operationType=='update'){  
                this.title="品类修改";              
                this.editorForm.id=row.id;
                this.editorForm.dicTypeName=row.dicTypeName;
                if(row.state=='N'){
                    this.editorForm.state=false
                }else{
                    this.editorForm.state=true
                }                
            }else{
                //添加
                this.title="品类新增";
                this.editorForm.state=true;
                this.editorForm=common.emptyModel(this.editorForm,["state"]);
            }
            this.categoryDialog=true;
        },
        query(){
            this.getTableParam.param=this.form
            this.$refs.myTable.query(1);
        },
        submitForm(formName) {
            let usercode=common.getCurrUser().userCode;
            let url="";
            let param=Object.assign({},this.editorForm);    
                param.createUser=usercode;
                param.modifyUser=usercode;            
            if(param.state){
                param.state='Y'
            }else{
                param.state='N'
            }
            if(this.operationType=='add'){
                url="/extwarapi/api/dicProdType/add";
            }else{
                url="/extwarapi/api/dicProdType/update";
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.axios.post(url, param).then((resp) => { 
                        if(resp.data.code=='0000'){
                            this.$alert("操作成功!", '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.categoryDialog=false;
                                    this.$refs["myTable"].query(1); 
                                }
                            });
                        }else{
                            this.$alert(resp.data.msg, '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                
                                }
                            });
                            return;
                        }
               
                    }).catch((resp) => {
                        //console.log('error', resp); 
                    })
                } else {
                    //console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.categoryDialog=false;
            this.$refs[formName].resetFields();            
        },
        changeSelct(value){
            this.form.state=value;
        }
       
    }
 
}
</script>
<style lang="scss" scoped>

</style>